import React from 'react'
import HomeNavbar from './MobileHomeNavbar'

const Header = () => {
  return (
    <div className="flex flex-col">
      <div
        className="relative text-center bg-cover bg-center bg-no-repeat bg-black h-screen"
        style={{
          // backgroundImage: `url('/prjimg/RagonInstituteII/ragon_edit.webp')`
          // backgroundImage: `url('/prjimg/MassMutualFanPier/massmutual_new.webp')`
          backgroundImage: `url('/prjimg/GoogleHQ/googlehq.png')`,
        }}
      >
        {/* dark overlay to dim the background image */}
        <div className="absolute inset-0 bg-black opacity-30 pointer-events-none z-10" />

        {/* Navbar stays at the top */}
        <div className="relative z-30">
          <HomeNavbar color="white" />
        </div>

        {/* Centered heading overlay */}
        <div className="absolute inset-0 z-20 flex items-center justify-center px-4">
          <div
            className="text-center font-display font-semi max-w-3xl"
            style={{ opacity: 0, animation: "fadeInFromLeft 1s ease-in forwards" }}
          >
            <h1 className="px-2 sm:px-10 text-3xl sm:text-4xl font-bold text-white leading-tight">
              Transforming <span className="text-gold">architectural vision </span>
              into <span className="text-gold">eco-sustainable</span>
              <br /> building facades.
            </h1>
          </div>
        </div>

        {/* Bottom secondary text */}
        {/* <div className="absolute bottom-8 left-0 right-0 z-10 flex justify-center">
          <h2 className="text-3xl text-white">Build with confidence.</h2>
        </div> */}
      </div>
    </div>
  );
};

export default Header